import React, { useState } from "react";

interface JourneyStep {
  title: string;
  description: string;
  details: string[];
}

interface ServiceJourneyProps {
  title?: string;
  steps: JourneyStep[];
}

const ServiceJourney: React.FC<ServiceJourneyProps> = ({
  title = "Our Web Creation Journey",
  steps,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="service-journey-section mt-40 mb-40">
      <div className="journey-container" style={{
        background: "rgba(255, 255, 255, 0.06)",
        borderRadius: "18px",
        padding: "50px 40px",
        position: "relative",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
      }}>
        <h2 className="journey-title text-center mb-50 wow fadeInUp" data-wow-delay="100ms" style={{
          color: "#ffffff",
          fontSize: "2.5rem",
          fontWeight: "700",
          marginBottom: "60px"
        }}>
          {title}
        </h2>

        <div className="journey-timeline" style={{ position: "relative" }}>
          {/* Vertical line */}
          <div style={{
            position: "absolute",
            left: "30px",
            top: "0",
            bottom: "0",
            width: "4px",
            background: "linear-gradient(180deg, rgba(255,140,0,0.9) 0%, rgba(255,140,0,0.4) 100%)",
            borderRadius: "2px",
          }}></div>

          {steps.map((step, index) => (
            <div 
              key={index} 
              className="journey-step wow fadeInUp" 
              data-wow-delay={`${200 + index * 150}ms`}
              style={{
                position: "relative",
                paddingLeft: "90px",
                marginBottom: index < steps.length - 1 ? "50px" : "0",
              }}
            >
              {/* Step number circle */}
              <div style={{
                position: "absolute",
                left: "0",
                top: "0",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                background: hoveredIndex === index 
                  ? "linear-gradient(135deg, rgba(255,140,0,1) 0%, rgba(255,140,0,0.8) 100%)"
                  : "linear-gradient(135deg, rgba(255,140,0,0.9) 0%, rgba(255,140,0,0.7) 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#ffffff",
                boxShadow: hoveredIndex === index 
                  ? "0 8px 25px rgba(255,140,0,0.6)"
                  : "0 4px 15px rgba(255,140,0,0.4)",
                zIndex: 1,
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: hoveredIndex === index ? "scale(1.15)" : "scale(1)",
              }}>
                {index + 1}
              </div>

              {/* Step content */}
              <div 
                style={{
                  background: hoveredIndex === index 
                    ? "rgba(255, 255, 255, 0.08)" 
                    : "rgba(255, 255, 255, 0.05)",
                  borderRadius: "12px",
                  padding: "25px 30px",
                  backdropFilter: "blur(10px)",
                  border: hoveredIndex === index 
                    ? "1px solid rgba(255,140,0,0.3)"
                    : "1px solid rgba(255, 255, 255, 0.1)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: hoveredIndex === index ? "translateY(-5px)" : "translateY(0)",
                  boxShadow: hoveredIndex === index 
                    ? "0 15px 35px rgba(255,140,0,0.2)"
                    : "0 5px 15px rgba(0,0,0,0.1)",
                  cursor: "pointer"
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <h3 style={{
                  color: hoveredIndex === index ? "rgba(255,140,0,1)" : "#ffffff",
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "15px",
                  transition: "color 0.3s ease"
                }}>
                  {step.title}
                </h3>
                <p style={{
                  color: "rgba(255, 255, 255, 0.85)",
                  fontSize: "0.95rem",
                  lineHeight: "1.7",
                  marginBottom: "15px"
                }}>
                  {step.description}
                </p>
                {step.details && step.details.length > 0 && (
                  <ul style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px"
                  }}>
                    {step.details.map((detail, idx) => (
                      <li key={idx} style={{
                        color: "rgba(255, 255, 255, 0.7)",
                        fontSize: "0.85rem",
                        padding: "6px 14px",
                        background: hoveredIndex === index 
                          ? "rgba(255,140,0,0.15)"
                          : "rgba(255, 255, 255, 0.05)",
                        borderRadius: "6px",
                        border: hoveredIndex === index
                          ? "1px solid rgba(255,140,0,0.3)"
                          : "1px solid rgba(255, 255, 255, 0.1)",
                        transition: "all 0.3s ease"
                      }}>
                        • {detail}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceJourney;
